import React from 'react'
import SettingsBody from '../../../components/AdminDashboard/Settings/SettingsBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const Settings = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Setting Body */}
            <SettingsBody />

        </div>
    )
}

export default Settings